import SandboxBehavior from './SandboxBehavior.js';
import DrawDeckBehavior from './DrawDeckBehavior.js';
import OnboardingBehavior from './OnboardingBehavior.js';
import FairDisplayBehavior from './FairDisplayBehavior.js';

const behaviors = {
    SandboxBehavior: SandboxBehavior,
    DrawDeckBehavior: DrawDeckBehavior,
    OnboardingBehavior: OnboardingBehavior,
    FairDisplayBehavior: FairDisplayBehavior,
};

export function createBehavior(name, space, interaction, runtimeState) {
    const BehaviorClass = behaviors[name] || SandboxBehavior;
    return new BehaviorClass(space, interaction, runtimeState);
}

export function registerBehavior(type, BehaviorClass) {
    behaviors[type] = BehaviorClass;
}
